import { Component, OnDestroy, OnInit } from '@angular/core';
import { MedicoService } from "../../services/medico.service";
import { MarcacaoService } from "../../services/marcacao.service";
import { MarcacaoModel } from "../../models/marcacao.model";
import { MedicoModel } from "../../models/medico.model";
import { AuthTokenService } from "../../services/auth-token.service";
import { EspecialidadeService } from "../../services/especialidade.service";
import { EspecialidadeModel } from "../../models/especialidade.model";
import { SharedMarcacaoService } from "../../services/shared-marcacao.service";
import { NavegacaoPorAbasService } from "../../services/navegacao-por-abas.service";
import { AbaEnum } from "../../enums/aba.enum";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";
import { Subscription } from 'rxjs';

const StatusAtendimento = {
  AGENDADO: 1, // Vermelho
  CONFIRMADO: 2, // Vermelho
  CANCELADO: 3, // Vermelho
  AGUARDANDO: 4, // Azul
  EM_ATENDIMENTO: 5, // Azul
  REALIZADO: 6, // Verde
  FINALIZADO: 7, // Verde
};

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit, OnDestroy {
  protected atendimentos: MarcacaoModel[] = [];
  protected atendimentoAtual: MarcacaoModel | undefined;
  protected medico: MedicoModel | undefined;
  protected especialidade: EspecialidadeModel | undefined;
  protected timerIntervaloRefresh: any;
  private subscricoes = new Subscription();

  protected nomePaciente: string | undefined = undefined;
  protected dataAtendimento: Date = new Date();

  protected get dataAtendimentoFormatada(): string {
    return this.dataAtendimento.toISOString().split('T')[0];
  }

  protected set dataAtendimentoFormatada(value: string) {
    // Converter data para o formato UTC
    let dataSemTimeZone = new Date(value);
    let utc = dataSemTimeZone.getTime() + dataSemTimeZone.getTimezoneOffset() * 60000;
    this.dataAtendimento = new Date(utc);

    this.obterAgenda();
  }

  constructor(private agendaService: MarcacaoService,
    private medicoService: MedicoService,
    private especialidadeService: EspecialidadeService,
    private authTokenService: AuthTokenService,
    private sharedMarcacaoService: SharedMarcacaoService,
    private navegacaoPorAbasService: NavegacaoPorAbasService,
    private toastrService: ToastrService) {
  }

  ngOnInit() {
    const medicoId = this.authTokenService.medicoId;
    this.medicoService.get(medicoId!).subscribe((res) => {
      this.medico = res.data;
      this.obterDadosClinica();
      this.obterAgenda();
    });

    this.criarTimerIntervaloRefresh();

this.subscricoes.add(    this.navegacaoPorAbasService.abaAtual.subscribe((aba) => {
      if (aba === AbaEnum.Agenda) {
        this.sharedMarcacaoService.setMarcacaoAtual(undefined);
        this.obterAgenda();
        this.criarTimerIntervaloRefresh();
      } else {
        if (aba === AbaEnum.ProntuariosAvulsos) {
          this.sharedMarcacaoService.setMarcacaoAtual(undefined);
        }
        this.excluirTimerIntervaloRefresh();
      }
    }));
this.subscricoes.add(
    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      this.atendimentoAtual = res;
    }));
  }

  ngOnDestroy() {
    this.excluirTimerIntervaloRefresh();
  }

  criarTimerIntervaloRefresh() {
    if (!this.timerIntervaloRefresh) {
      this.timerIntervaloRefresh = window.setInterval(() => {
        this.obterAgenda();
      }, 15000);
    }
  }

  excluirTimerIntervaloRefresh() {
    if (this.timerIntervaloRefresh) {
      window.clearInterval(this.timerIntervaloRefresh);
    }
  }

  obterDadosClinica() {   

    this.especialidadeService.getByMedico(this.medico!).subscribe((res) => {
      this.especialidade = res.data;
    });
  }

  obterAgenda() {
    if (this.nomePaciente == '') {
      this.nomePaciente = undefined;
    }
    this.agendaService.getAllAvulsosByFiltros(this.nomePaciente, undefined, this.dataAtendimento, undefined, undefined, this.medico!)
      .subscribe((res) => {
        let atendimentosMapeados = res.data.map((atendimento) =>
          Object.assign(new MarcacaoModel(), atendimento));

        this.atendimentos = atendimentosMapeados.sort((a, b) => {

          try {
            const dataA = new Date(a.data_Agenda);
            dataA.setHours(Math.floor(a.hora_Agenda / 100));
            dataA.setMinutes(a.hora_Agenda % 100);

            const dataB = new Date(b.data_Agenda);
            dataB.setHours(Math.floor(b.hora_Agenda / 100));
            dataB.setMinutes(b.hora_Agenda % 100);

            return dataA.getTime() - dataB.getTime();
          } catch (e) {

            return 0;
          }
        });
      });
  }

  public getStatusCor(atendimento: MarcacaoModel): string {
    switch (atendimento.status_Atendimento) {
      // Status Vermelho: 1, 2, 3
      case StatusAtendimento.AGENDADO:
      case StatusAtendimento.CONFIRMADO:
      case StatusAtendimento.CANCELADO:
        return 'status-vermelho';

      // Status Azul: 4, 5
      case StatusAtendimento.AGUARDANDO:
      case StatusAtendimento.EM_ATENDIMENTO:
        return 'status-azul';

      // Status Verde: 6, 7
      case StatusAtendimento.REALIZADO:
      case StatusAtendimento.FINALIZADO:
        return 'status-verde';

      default:
        return '';
    }
  }

  selecionouLinha(atendimento: MarcacaoModel) {

    if (!atendimento.podeAtender && environment.production) {
      this.toastrService.warning('Não é possível abrir uma consulta que não está sendo aguardada.', 'Atenção');
      return;
    } else if (!environment.production) {
      this.toastrService.info('Atendimento aberto em ambiente de desenvolvimento.', 'Atenção');
    }

    this.iniciarAtendimento(atendimento);
  }

  iniciarAtendimento(atendimento: MarcacaoModel) {
    var dataHoraAtual = new Date();
    var hoje = new Date(dataHoraAtual.toDateString());
    var horaAtual = parseInt(`${dataHoraAtual.getHours()}`.padStart(2, '0') + `${dataHoraAtual.getMinutes()}`.padStart(2, '0'));

    atendimento.status_Atendimento = 5;
    atendimento.emAtendimento = true;

    // if (!atendimento.data_Comparecimento) {
    //   atendimento.data_Comparecimento = hoje;
    //   atendimento.hora_Comparecimento = horaAtual;
    // }

    atendimento.data_Realizacao_Consulta = hoje;
    atendimento.hora_Realizacao_Consulta = horaAtual;

    this.sharedMarcacaoService.setMarcacaoAtual(atendimento);

    this.navegacaoPorAbasService.irParaAba(AbaEnum.Evolucao);
  }
}
